export default "__VITE_ASSET__8fc97f77__"